export function encodeURI(uri) {
    return uri.replace('+','%2B');
}